import React from "react";
const ExperienceBlockquote = ({ title, description, duration }) => {
  return (
    <blockquote className="blockquote bq-warning mb-4">
      <div className="row">
        <i
          className="fas fa-briefcase fa-x mb-1 mr-3 ml-3"
          aria-hidden="true"
        ></i>
        <h5 className="font-weight-bold mb-3">{title}</h5>
      </div>

      <p className="font-weight-bold mb-0 py-2 ml-1">{duration}</p>

      <p
        style={{ fontSize: "smaller" }}
        className="mb-0 ml-1 light-grey-text font-weight-bolder"
      >
        {description.map((data, index) => (
          <div key={index}>
            <i
              className="fa fa-caret-right mb-1 ml-1 mr-2"
              aria-hidden="true"
            ></i>
            {data}
            <br />
          </div>
        ))}
      </p>
    </blockquote>
  );
};

export default ExperienceBlockquote;
